import { Color } from '@/components/modules/CanvasEditor/color'
import { type Color as ColorType } from '@backend/lib/db/typeRoots/color'
import { type TextOptions, stringToRuns } from '@backend/lib/db/typeRoots/layoutNode'
import { type LayoutNode } from '@backend/lib/db/typeRoots/layoutNode'
import { type Role } from '@/stores/nodeStore'

// templates

type Templates = ((width: number, height: number) => LayoutNode[])[]

const _template01: LayoutNode[] = [
  {
    x: 0,
    y: 0,
    width: 1024,
    height: 1024,
    rotation: 0,
    visible: true,
    data: {
      type: 'image',
      source: {
        type: 'url',
        url: 'blob:https://app.getcassi.ai/4b7daca2-13ad-4696-838b-721a8e995b50',
      },
      isLoading: false,
      options: {
        mode: 'cover',
        opacity: 1,
        borderRadius: 0,
        borderWidth: 0,
        borderColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 255,
        },
      },
    },
    metadata: {
      role: 'image',
    },
  },
  {
    x: 147.3531451418205,
    y: 286.2052953935394,
    width: 729.293709716359,
    height: 268.8137932587558,
    rotation: 0,
    visible: true,
    data: {
      type: 'shape',
      isLoading: false,
      options: {
        shape: 'rectangle',
        fillColor: {
          r: 43,
          g: 67,
          b: 170,
          a: 255,
          index: 3,
        },
        fillOpacity: 1,
        strokeColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 255,
        },
        strokeOpacity: 1,
        lineWidth: 0,
        borderRadius: 25,
      },
    },
    metadata: {
      role: 'static',
    },
  },
  {
    x: 206.06753724487106,
    y: 320,
    width: 611.8649255102579,
    height: 100.61219202291733,
    rotation: 0,
    visible: true,
    data: {
      type: 'text',
      content: [
        {
          text: 'AI-Powered Content Revolution',
          fontFamily: 'Poppins',
          fontWeight: 600,
          fontStyle: 'normal',
          fontSize: 50,
          fontColor: {
            r: 255,
            g: 255,
            b: 255,
            a: 255,
            index: -1,
          },
        },
      ],
      editMode: false,
      isLoading: false,
      options: {
        fontFamily: 'Poppins',
        fontWeight: 600,
        fontStyle: 'normal',
        fontSize: 50,
        fontColor: {
          r: 255,
          g: 255,
          b: 255,
          a: 255,
          index: -1,
        },
        lineHeight: 1,
        strokeWidth: 0,
        strokeColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 255,
        },
        horizontalAlign: 'center',
        verticalAlign: 'top',
        backdropColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 0,
        },
        backdropPadding: 0,
        backdropBorderRadius: 0,
        backdropBorderWidth: 0,
        backdropBorderColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 255,
        },
      },
    },
    metadata: {
      role: 'header',
    },
  },
  {
    x: 417.1311384892271,
    y: 544,
    width: 189.73772302154578,
    height: 42.679341413255315,
    rotation: 0,
    visible: true,
    data: {
      type: 'text',
      content: [
        {
          text: 'Try CASSI Now',
          fontFamily: 'Poppins',
          fontWeight: 600,
          fontStyle: 'normal',
          fontSize: 24,
          fontColor: {
            r: 157,
            g: 20,
            b: 160,
            a: 255,
            index: 4,
          },
        },
      ],
      editMode: false,
      isLoading: false,
      options: {
        fontFamily: 'Poppins',
        fontWeight: 600,
        fontStyle: 'normal',
        fontSize: 24,
        fontColor: {
          r: 157,
          g: 20,
          b: 160,
          a: 255,
          index: 4,
        },
        lineHeight: 1,
        strokeWidth: 0,
        strokeColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 255,
        },
        horizontalAlign: 'center',
        verticalAlign: 'center',
        backdropColor: {
          r: 255,
          g: 255,
          b: 255,
          a: 255,
        },
        backdropPadding: 14,
        backdropBorderRadius: 50,
        backdropBorderWidth: 0,
        backdropBorderColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 255,
        },
      },
    },
    metadata: {
      role: 'cta',
    },
  },
  // {
  //   x: 467,
  //   y: 823,
  //   width: 93.8544315386423,
  //   height: 87.39873258373404,
  //   rotation: 0,
  //   visible: true,
  //   data: {
  //     type: 'image',
  //     source: {
  //       type: 'url',
  //       url: 'https://media.licdn.com/dms/image/v2/D4E0BAQEHJJj24fi3Dw/company-logo_200_200/company-logo_200_200/0/1724406331151/magig_logo?e=2147483647&v=beta&t=cgPaR9pZH-QlxP6ZhfMY9nQu8lQqNtmD7K8vOKSn6bU',
  //     },
  //     isLoading: false,
  //     options: {
  //       mode: 'contain',
  //       opacity: 1,
  //       borderRadius: 20,
  //       borderWidth: 0,
  //       borderColor: {
  //         r: 0,
  //         g: 0,
  //         b: 0,
  //         a: 255,
  //       },
  //     },
  //   },
  //   metadata: {
  //     role: 'logo',
  //   },
  // },
  {
    x: 169.4366125886312,
    y: 434,
    width: 685.1267748227376,
    height: 58.65189776718955,
    rotation: 0,
    visible: true,
    data: {
      type: 'text',
      content: [
        {
          text: 'Boost productivity and maintain brand consistency across all platforms with CASSI.',
          fontFamily: 'Poppins',
          fontWeight: 400,
          fontStyle: 'normal',
          fontSize: 24,
          fontColor: {
            r: 255,
            g: 255,
            b: 255,
            a: 255,
          },
        },
      ],
      editMode: false,
      isLoading: false,
      options: {
        fontFamily: 'Poppins',
        fontWeight: 400,
        fontStyle: 'normal',
        fontSize: 24,
        fontColor: {
          r: 255,
          g: 255,
          b: 255,
          a: 255,
        },
        lineHeight: 1,
        strokeWidth: 0,
        strokeColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 255,
        },
        horizontalAlign: 'center',
        verticalAlign: 'center',
        backdropColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 1,
        },
        backdropPadding: 0,
        backdropBorderRadius: 0,
        backdropBorderWidth: 0,
        backdropBorderColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 255,
        },
      },
    },
    metadata: {
      role: 'text',
    },
  },
]

const _template02: LayoutNode[] = [
  {
    x: 0,
    y: 0,
    width: 1024,
    height: 1024,
    rotation: 0,
    visible: true,
    data: {
      type: 'image',
      source: {
        type: 'url',
        url: 'blob:https://app.getcassi.ai/b0f99f96-8996-45ae-8ac9-647cd41f6c99',
      },
      isLoading: false,
      options: {
        mode: 'cover',
        opacity: 1,
        borderRadius: 0,
        borderWidth: 0,
        borderColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 255,
        },
      },
    },
    metadata: {
      role: 'image',
    },
  },
  {
    x: 45,
    y: 45,
    width: 705.5262730561827,
    height: 291.70227034727816,
    rotation: 0,
    visible: true,
    data: {
      type: 'shape',
      isLoading: false,
      options: {
        shape: 'rectangle',
        fillColor: {
          r: 43,
          g: 66,
          b: 171,
          a: 255,
          index: 4,
        },
        fillOpacity: 1,
        strokeColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 255,
        },
        strokeOpacity: 1,
        lineWidth: 0,
        borderRadius: 25,
      },
    },
    metadata: {
      role: 'static',
    },
  },
  {
    x: 81.38683238459902,
    y: 71,
    width: 632.7526082869847,
    height: 105,
    rotation: 0,
    visible: true,
    data: {
      type: 'text',
      content: [
        {
          text: 'AI-Powered Content Revolution',
          fontFamily: 'Poppins',
          fontWeight: 700,
          fontStyle: 'normal',
          fontSize: 50,
          fontColor: {
            r: 255,
            g: 255,
            b: 255,
            a: 255,
          },
        },
      ],
      editMode: false,
      isLoading: false,
      options: {
        fontFamily: 'Poppins',
        fontWeight: 700,
        fontStyle: 'normal',
        fontSize: 50,
        fontColor: {
          r: 255,
          g: 255,
          b: 255,
          a: 255,
        },
        lineHeight: 1,
        strokeWidth: 0,
        strokeColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 255,
        },
        horizontalAlign: 'left',
        verticalAlign: 'top',
        backdropColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 0,
        },
        backdropPadding: 0,
        backdropBorderRadius: 0,
        backdropBorderWidth: 0,
        backdropBorderColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 255,
        },
      },
    },
    metadata: {
      role: 'header',
    },
  },
  {
    x: 83.211977508355,
    y: 190.85113517363908,
    width: 629.1023180394727,
    height: 69.77631857228832,
    rotation: 0,
    visible: true,
    data: {
      type: 'text',
      content: [
        {
          text: 'Boost productivity and maintain brand consistency across all platforms with CASSI.',
          fontFamily: 'Poppins',
          fontWeight: 500,
          fontStyle: 'normal',
          fontSize: 24,
          fontColor: {
            r: 255,
            g: 255,
            b: 255,
            a: 255,
          },
        },
      ],
      editMode: false,
      isLoading: false,
      options: {
        fontFamily: 'Poppins',
        fontWeight: 500,
        fontStyle: 'normal',
        fontSize: 24,
        fontColor: {
          r: 255,
          g: 255,
          b: 255,
          a: 255,
        },
        lineHeight: 1.2,
        strokeWidth: 0,
        strokeColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 255,
        },
        horizontalAlign: 'left',
        verticalAlign: 'top',
        backdropColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 0,
        },
        backdropPadding: 0,
        backdropBorderRadius: 0,
        backdropBorderWidth: 0,
        backdropBorderColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 255,
        },
      },
    },
    metadata: {
      role: 'text',
    },
  },
  {
    x: 409.52690419172694,
    y: 911.3669855778312,
    width: 204.94619161654612,
    height: 54.62678674452718,
    rotation: 0,
    visible: true,
    data: {
      type: 'text',
      content: [
        {
          text: 'Try CASSI Now',
          fontFamily: 'Poppins',
          fontWeight: 600,
          fontStyle: 'normal',
          fontSize: 24,
          fontColor: {
            r: 157,
            g: 20,
            b: 160,
            a: 255,
            index: -1,
          },
        },
      ],
      editMode: false,
      isLoading: false,
      options: {
        fontFamily: 'Poppins',
        fontWeight: 600,
        fontStyle: 'normal',
        fontSize: 24,
        fontColor: {
          r: 157,
          g: 20,
          b: 160,
          a: 255,
          index: -1,
        },
        lineHeight: 1,
        strokeWidth: 0,
        strokeColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 255,
        },
        horizontalAlign: 'center',
        verticalAlign: 'center',
        backdropColor: {
          r: 255,
          g: 255,
          b: 255,
          a: 255,
        },
        backdropPadding: 15,
        backdropBorderRadius: 50,
        backdropBorderWidth: 0,
        backdropBorderColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 255,
        },
      },
    },
    metadata: {
      role: 'cta',
    },
  },
  {
    x: 85.83386641019263,
    y: 273,
    width: 647.3860755630686,
    height: 29.34336525307799,
    rotation: 0,
    visible: true,
    data: {
      type: 'text',
      content: [
        {
          text: '#AIContentCreation #BrandConsistency #SocialMediaEfficiency',
          fontFamily: 'Poppins',
          fontWeight: 400,
          fontStyle: 'normal',
          fontSize: 20,
          fontColor: {
            r: 233,
            g: 233,
            b: 233,
            a: 255,
            index: -1,
          },
        },
      ],
      editMode: false,
      isLoading: false,
      options: {
        fontFamily: 'Poppins',
        fontWeight: 400,
        fontStyle: 'normal',
        fontSize: 20,
        fontColor: {
          r: 233,
          g: 233,
          b: 233,
          a: 255,
          index: -1,
        },
        lineHeight: 1,
        strokeWidth: 0,
        strokeColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 255,
        },
        horizontalAlign: 'left',
        verticalAlign: 'top',
        backdropColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 0,
        },
        backdropPadding: 0,
        backdropBorderRadius: 0,
        backdropBorderWidth: 0,
        backdropBorderColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 255,
        },
      },
    },
    metadata: {
      role: 'hashtags',
    },
  },
  // {
  //   x: 893.8544299934483,
  //   y: 894.3607579001897,
  //   width: 88.14557000655168,
  //   height: 88.6392420998103,
  //   rotation: 0,
  //   visible: true,
  //   data: {
  //     type: 'image',
  //     source: {
  //       type: 'url',
  //       url: 'https://media.licdn.com/dms/image/v2/D4E0BAQEHJJj24fi3Dw/company-logo_200_200/company-logo_200_200/0/1724406331151/magig_logo?e=2147483647&v=beta&t=cgPaR9pZH-QlxP6ZhfMY9nQu8lQqNtmD7K8vOKSn6bU',
  //     },
  //     isLoading: false,
  //     options: {
  //       mode: 'contain',
  //       opacity: 1,
  //       borderRadius: 20,
  //       borderWidth: 0,
  //       borderColor: {
  //         r: 0,
  //         g: 0,
  //         b: 0,
  //         a: 255,
  //       },
  //     },
  //   },
  //   metadata: {
  //     role: 'logo',
  //   },
  // },
]

const _template03: LayoutNode[] = [
  {
    x: -8.522985020290434,
    y: -6.871026685015977,
    width: 1041.0459700405809,
    height: 1037.742053370032,
    rotation: 0,
    visible: true,
    data: {
      type: 'shape',
      isLoading: false,
      options: {
        shape: 'rectangle',
        fillColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 255,
          index: 4,
        },
        fillOpacity: 1,
        strokeColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 255,
        },
        strokeOpacity: 1,
        lineWidth: 0,
        borderRadius: 0,
      },
    },
    metadata: {
      role: 'static',
    },
  },
  {
    x: 0,
    y: 744.2704810570945,
    width: 1024,
    height: 194.40989789300028,
    rotation: 0,
    visible: true,
    data: {
      type: 'text',
      content: [
        {
          text: 'Try CASSI Now',
          fontFamily: 'Lato',
          fontWeight: 900,
          fontStyle: 'normal',
          fontSize: 145,
          fontColor: {
            r: 157,
            g: 20,
            b: 160,
            a: 0,
            index: -1,
          },
        },
      ],
      editMode: false,
      isLoading: false,
      options: {
        fontFamily: 'Lato',
        fontWeight: 900,
        fontStyle: 'normal',
        fontSize: 145,
        fontColor: {
          r: 157,
          g: 20,
          b: 160,
          a: 0,
          index: -1,
        },
        lineHeight: 1,
        strokeWidth: 2,
        strokeColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 255,
          index: 2,
        },
        horizontalAlign: 'center',
        verticalAlign: 'center',
        backdropColor: {
          r: 255,
          g: 255,
          b: 255,
          a: 0,
          index: -1,
        },
        backdropPadding: 0,
        backdropBorderRadius: 0,
        backdropBorderWidth: 0,
        backdropBorderColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 255,
        },
      },
    },
    metadata: {
      role: 'cta',
    },
  },
  {
    x: 0,
    y: 553.4010590956545,
    width: 1024,
    height: 194.40989789300028,
    rotation: 0,
    visible: true,
    data: {
      type: 'text',
      content: [
        {
          text: 'Try CASSI Now',
          fontFamily: 'Lato',
          fontWeight: 900,
          fontStyle: 'normal',
          fontSize: 145,
          fontColor: {
            r: 157,
            g: 20,
            b: 160,
            a: 0,
            index: -1,
          },
        },
      ],
      editMode: false,
      isLoading: false,
      options: {
        fontFamily: 'Lato',
        fontWeight: 900,
        fontStyle: 'normal',
        fontSize: 145,
        fontColor: {
          r: 157,
          g: 20,
          b: 160,
          a: 0,
          index: -1,
        },
        lineHeight: 1,
        strokeWidth: 2,
        strokeColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 255,
          index: 2,
        },
        horizontalAlign: 'center',
        verticalAlign: 'center',
        backdropColor: {
          r: 255,
          g: 255,
          b: 255,
          a: 0,
          index: -1,
        },
        backdropPadding: 0,
        backdropBorderRadius: 0,
        backdropBorderWidth: 0,
        backdropBorderColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 255,
        },
      },
    },
    metadata: {
      role: 'cta',
    },
  },
  {
    x: 0,
    y: 383.0711930278334,
    width: 1024,
    height: 194.40989789300028,
    rotation: 0,
    visible: true,
    data: {
      type: 'text',
      content: [
        {
          text: 'Try CASSI Now',
          fontFamily: 'Lato',
          fontWeight: 900,
          fontStyle: 'normal',
          fontSize: 145,
          fontColor: {
            r: 157,
            g: 20,
            b: 160,
            a: 0,
            index: -1,
          },
        },
      ],
      editMode: false,
      isLoading: false,
      options: {
        fontFamily: 'Lato',
        fontWeight: 900,
        fontStyle: 'normal',
        fontSize: 145,
        fontColor: {
          r: 157,
          g: 20,
          b: 160,
          a: 0,
          index: -1,
        },
        lineHeight: 1,
        strokeWidth: 2,
        strokeColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 255,
          index: 2,
        },
        horizontalAlign: 'center',
        verticalAlign: 'center',
        backdropColor: {
          r: 255,
          g: 255,
          b: 255,
          a: 0,
          index: -1,
        },
        backdropPadding: 0,
        backdropBorderRadius: 0,
        backdropBorderWidth: 0,
        backdropBorderColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 255,
        },
      },
    },
    metadata: {
      role: 'cta',
    },
  },
  {
    x: 0,
    y: 188.66129513483307,
    width: 1024,
    height: 194.40989789300028,
    rotation: 0,
    visible: true,
    data: {
      type: 'text',
      content: [
        {
          text: 'Try CASSI Now',
          fontFamily: 'Lato',
          fontWeight: 900,
          fontStyle: 'normal',
          fontSize: 145,
          fontColor: {
            r: 157,
            g: 20,
            b: 160,
            a: 0,
            index: -1,
          },
        },
      ],
      editMode: false,
      isLoading: false,
      options: {
        fontFamily: 'Lato',
        fontWeight: 900,
        fontStyle: 'normal',
        fontSize: 145,
        fontColor: {
          r: 157,
          g: 20,
          b: 160,
          a: 0,
          index: -1,
        },
        lineHeight: 1,
        strokeWidth: 2,
        strokeColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 255,
          index: 2,
        },
        horizontalAlign: 'center',
        verticalAlign: 'center',
        backdropColor: {
          r: 255,
          g: 255,
          b: 255,
          a: 0,
          index: -1,
        },
        backdropPadding: 0,
        backdropBorderRadius: 0,
        backdropBorderWidth: 0,
        backdropBorderColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 255,
        },
      },
    },
    metadata: {
      role: 'cta',
    },
  },
  {
    x: 0,
    y: -0.20494894650013862,
    width: 1024,
    height: 194.40989789300028,
    rotation: 0,
    visible: true,
    data: {
      type: 'text',
      content: [
        {
          text: 'Try CASSI Now',
          fontFamily: 'Lato',
          fontWeight: 900,
          fontStyle: 'normal',
          fontSize: 145,
          fontColor: {
            r: 157,
            g: 20,
            b: 160,
            a: 0,
            index: -1,
          },
        },
      ],
      editMode: false,
      isLoading: false,
      options: {
        fontFamily: 'Lato',
        fontWeight: 900,
        fontStyle: 'normal',
        fontSize: 145,
        fontColor: {
          r: 157,
          g: 20,
          b: 160,
          a: 0,
          index: -1,
        },
        lineHeight: 1,
        strokeWidth: 2,
        strokeColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 255,
          index: 2,
        },
        horizontalAlign: 'center',
        verticalAlign: 'center',
        backdropColor: {
          r: 255,
          g: 255,
          b: 255,
          a: 0,
          index: -1,
        },
        backdropPadding: 0,
        backdropBorderRadius: 0,
        backdropBorderWidth: 0,
        backdropBorderColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 255,
        },
      },
    },
    metadata: {
      role: 'cta',
    },
  },
  {
    x: 79,
    y: 109.5088378223289,
    width: 892.8385832194585,
    height: 352.7148125180086,
    rotation: 0,
    visible: true,
    data: {
      type: 'shape',
      isLoading: false,
      options: {
        shape: 'rectangle',
        fillColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 114,
          index: -1,
        },
        fillOpacity: 1,
        strokeColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 255,
        },
        strokeOpacity: 1,
        lineWidth: 0,
        borderRadius: 25,
      },
    },
    metadata: {
      role: 'static',
    },
  },
  {
    x: 63.068271966044676,
    y: 97,
    width: 897.8634560679106,
    height: 346.3133136762747,
    rotation: 0,
    visible: true,
    data: {
      type: 'shape',
      isLoading: false,
      options: {
        shape: 'rectangle',
        fillColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 255,
          index: 3,
        },
        fillOpacity: 1,
        strokeColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 255,
        },
        strokeOpacity: 1,
        lineWidth: 0,
        borderRadius: 25,
      },
    },
    metadata: {
      role: 'static',
    },
  },
  {
    x: 311.1768421081433,
    y: 488.760617485586,
    width: 428.48489900317185,
    height: 427.239382514414,
    rotation: 0,
    visible: true,
    data: {
      type: 'shape',
      isLoading: false,
      options: {
        shape: 'rectangle',
        fillColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 114,
          index: -1,
        },
        fillOpacity: 1,
        strokeColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 255,
        },
        strokeOpacity: 1,
        lineWidth: 0,
        borderRadius: 25,
      },
    },
    metadata: {
      role: 'static',
    },
  },
  {
    x: 0,
    y: 916,
    width: 1024,
    height: 194.40989789300028,
    rotation: 0,
    visible: true,
    data: {
      type: 'text',
      content: [
        {
          text: 'Try CASSI Now',
          fontFamily: 'Lato',
          fontWeight: 900,
          fontStyle: 'normal',
          fontSize: 145,
          fontColor: {
            r: 157,
            g: 20,
            b: 160,
            a: 0,
            index: -1,
          },
        },
      ],
      editMode: false,
      isLoading: false,
      options: {
        fontFamily: 'Lato',
        fontWeight: 900,
        fontStyle: 'normal',
        fontSize: 145,
        fontColor: {
          r: 157,
          g: 20,
          b: 160,
          a: 0,
          index: -1,
        },
        lineHeight: 1,
        strokeWidth: 2,
        strokeColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 255,
          index: 2,
        },
        horizontalAlign: 'center',
        verticalAlign: 'center',
        backdropColor: {
          r: 255,
          g: 255,
          b: 255,
          a: 0,
          index: -1,
        },
        backdropPadding: 0,
        backdropBorderRadius: 0,
        backdropBorderWidth: 0,
        backdropBorderColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 255,
        },
      },
    },
    metadata: {
      role: 'cta',
    },
  },
  {
    x: 299.41138775217746,
    y: 483.36782698803256,
    width: 425.1772244956451,
    height: 410.99293091215714,
    rotation: 0,
    visible: true,
    data: {
      type: 'image',
      source: {
        type: 'url',
        url: 'blob:https://app.getcassi.ai/1ff78237-25bc-4512-a867-06bc22131b31',
      },
      isLoading: false,
      options: {
        mode: 'cover',
        opacity: 1,
        borderRadius: 33,
        borderWidth: 0,
        borderColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 255,
        },
      },
    },
    metadata: {
      role: 'image',
    },
  },
  // {
  //   x: 903,
  //   y: 894.3607579001896,
  //   width: 88.14557000655168,
  //   height: 88.6392420998103,
  //   rotation: 0,
  //   visible: true,
  //   data: {
  //     type: 'image',
  //     source: {
  //       type: 'url',
  //       url: 'https://media.licdn.com/dms/image/v2/D4E0BAQEHJJj24fi3Dw/company-logo_200_200/company-logo_200_200/0/1724406331151/magig_logo?e=2147483647&v=beta&t=cgPaR9pZH-QlxP6ZhfMY9nQu8lQqNtmD7K8vOKSn6bU',
  //     },
  //     isLoading: false,
  //     options: {
  //       mode: 'contain',
  //       opacity: 1,
  //       borderRadius: 20,
  //       borderWidth: 0,
  //       borderColor: {
  //         r: 0,
  //         g: 0,
  //         b: 0,
  //         a: 255,
  //       },
  //     },
  //   },
  //   metadata: {
  //     role: 'logo',
  //   },
  // },
  {
    x: 94.79969549567966,
    y: 138,
    width: 834.4006090086407,
    height: 163.92874359382475,
    rotation: 0,
    visible: true,
    data: {
      type: 'text',
      content: [
        {
          text: 'AI-Powered Content Revolution',
          fontFamily: 'Inter',
          fontWeight: 700,
          fontStyle: 'normal',
          fontSize: 89,
          fontColor: {
            r: 255,
            g: 255,
            b: 255,
            a: 255,
            index: -1,
          },
        },
      ],
      editMode: false,
      isLoading: false,
      options: {
        fontFamily: 'Inter',
        fontWeight: 700,
        fontStyle: 'normal',
        fontSize: 89,
        fontColor: {
          r: 255,
          g: 255,
          b: 255,
          a: 255,
          index: -1,
        },
        lineHeight: 1,
        strokeWidth: 0,
        strokeColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 255,
        },
        horizontalAlign: 'center',
        verticalAlign: 'center',
        backdropColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 1,
        },
        backdropPadding: 0,
        backdropBorderRadius: 0,
        backdropBorderWidth: 0,
        backdropBorderColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 255,
        },
      },
    },
    metadata: {
      role: 'header',
    },
  },
  {
    x: 182.09424532653304,
    y: 314,
    width: 659.8115093469339,
    height: 115.38574793875148,
    rotation: 0,
    visible: true,
    data: {
      type: 'text',
      content: [
        {
          text: 'Boost productivity and maintain brand consistency across all platforms with CASSI.',
          fontFamily: 'Inter',
          fontWeight: 400,
          fontStyle: 'normal',
          fontSize: 27,
          fontColor: {
            r: 255,
            g: 255,
            b: 255,
            a: 255,
            index: -1,
          },
        },
      ],
      editMode: false,
      isLoading: false,
      options: {
        fontFamily: 'Inter',
        fontWeight: 400,
        fontStyle: 'normal',
        fontSize: 27,
        fontColor: {
          r: 255,
          g: 255,
          b: 255,
          a: 255,
          index: -1,
        },
        lineHeight: 1,
        strokeWidth: 0,
        strokeColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 255,
        },
        horizontalAlign: 'center',
        verticalAlign: 'center',
        backdropColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 1,
        },
        backdropPadding: 0,
        backdropBorderRadius: 0,
        backdropBorderWidth: 0,
        backdropBorderColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 255,
        },
      },
    },
    metadata: {
      role: 'text',
    },
  },
]

const _template04: LayoutNode[] = [
  {
    x: 0,
    y: 1.1368683772161603e-13,
    width: 682.7907307942712,
    height: 1023.9999999999998,
    rotation: 0,
    visible: true,
    data: {
      type: 'image',
      source: {
        type: 'url',
        url: 'blob:https://app.getcassi.ai/8b571163-30c1-49ab-b851-1a82ccf2dd2a',
      },
      isLoading: false,
      options: {
        mode: 'cover',
        opacity: 1,
        borderRadius: 0,
        borderWidth: 0,
        borderColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 255,
        },
      },
    },
    metadata: {
      role: 'image',
    },
  },
  {
    x: 241.14021316823937,
    y: 108,
    width: 1325.428679300252,
    height: 2129.1569315592455,
    rotation: 36,
    visible: true,
    data: {
      type: 'shape',
      isLoading: false,
      options: {
        shape: 'rectangle',
        fillColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 255,
          index: 3,
        },
        fillOpacity: 1,
        strokeColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 255,
        },
        strokeOpacity: 1,
        lineWidth: 0,
        borderRadius: 0,
      },
    },
    metadata: {
      role: 'static',
    },
  },
  {
    x: 437.16265119142713,
    y: 103.41309836970049,
    width: 1325.428679300252,
    height: 1628.3333333333342,
    rotation: 35,
    visible: true,
    data: {
      type: 'shape',
      isLoading: false,
      options: {
        shape: 'rectangle',
        fillColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 255,
          index: 4,
        },
        fillOpacity: 1,
        strokeColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 255,
        },
        strokeOpacity: 1,
        lineWidth: 0,
        borderRadius: 0,
      },
    },
    metadata: {
      role: 'static',
    },
  },
  {
    x: 41.00000000000006,
    y: -526.5300490175647,
    width: 1278.5359151384237,
    height: 768.1569315592449,
    rotation: 30,
    visible: true,
    data: {
      type: 'shape',
      isLoading: false,
      options: {
        shape: 'rectangle',
        fillColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 255,
          index: 2,
        },
        fillOpacity: 1,
        strokeColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 255,
        },
        strokeOpacity: 1,
        lineWidth: 0,
        borderRadius: 0,
      },
    },
    metadata: {
      role: 'static',
    },
  },
  {
    x: 44,
    y: -525.7262014402713,
    width: 1278.5359151384237,
    height: 756.156931559245,
    rotation: 30,
    visible: true,
    data: {
      type: 'shape',
      isLoading: false,
      options: {
        shape: 'rectangle',
        fillColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 255,
          index: 1,
        },
        fillOpacity: 1,
        strokeColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 255,
        },
        strokeOpacity: 1,
        lineWidth: 0,
        borderRadius: 0,
      },
    },
    metadata: {
      role: 'static',
    },
  },
  {
    x: 411.12406412760447,
    y: 22,
    width: 594.6015929138821,
    height: 183.82359822591158,
    rotation: 0,
    visible: true,
    data: {
      type: 'text',
      content: [
        {
          text: 'AI-Powered Content Revolution',
          fontFamily: 'Inter',
          fontWeight: 700,
          fontStyle: 'normal',
          fontSize: 59,
          fontColor: {
            r: 0,
            g: 0,
            b: 0,
            a: 255,
            index: -1,
          },
        },
      ],
      editMode: false,
      isLoading: false,
      options: {
        fontFamily: 'Inter',
        fontWeight: 700,
        fontStyle: 'normal',
        fontSize: 59,
        fontColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 255,
          index: -1,
        },
        lineHeight: 1.1300000000000001,
        strokeWidth: 0,
        strokeColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 255,
        },
        horizontalAlign: 'right',
        verticalAlign: 'center',
        backdropColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 1,
        },
        backdropPadding: 0,
        backdropBorderRadius: 0,
        backdropBorderWidth: 0,
        backdropBorderColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 255,
        },
      },
    },
    metadata: {
      role: 'header',
    },
  },
  {
    x: 682.7907307942713,
    y: 796.323598225912,
    width: 304.5199677563412,
    height: 80,
    rotation: 0,
    visible: true,
    data: {
      type: 'text',
      content: [
        {
          text: 'Try CASSI Now',
          fontFamily: 'Inter',
          fontWeight: 700,
          fontStyle: 'normal',
          fontSize: 32,
          fontColor: {
            r: 255,
            g: 255,
            b: 255,
            a: 255,
            index: -1,
          },
        },
      ],
      editMode: false,
      isLoading: false,
      options: {
        fontFamily: 'Inter',
        fontWeight: 700,
        fontStyle: 'normal',
        fontSize: 32,
        fontColor: {
          r: 255,
          g: 255,
          b: 255,
          a: 255,
          index: -1,
        },
        lineHeight: 1,
        strokeWidth: 0,
        strokeColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 255,
        },
        horizontalAlign: 'center',
        verticalAlign: 'center',
        backdropColor: {
          r: 255,
          g: 255,
          b: 255,
          a: 255,
          index: 3,
        },
        backdropPadding: 8,
        backdropBorderRadius: 25,
        backdropBorderWidth: 0,
        backdropBorderColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 255,
        },
      },
    },
    metadata: {
      role: 'cta',
    },
  },
  {
    x: 528.9309439625105,
    y: 608.2353973388673,
    width: 464.51996775634143,
    height: 150,
    rotation: 0,
    visible: true,
    data: {
      type: 'text',
      content: [
        {
          text: 'Boost productivity and maintain brand consistency across all platforms with CASSI.',
          fontFamily: 'Inter',
          fontWeight: 400,
          fontStyle: 'normal',
          fontSize: 29,
          fontColor: {
            r: 0,
            g: 0,
            b: 0,
            a: 255,
            index: 0,
          },
        },
      ],
      editMode: false,
      isLoading: false,
      options: {
        fontFamily: 'Inter',
        fontWeight: 400,
        fontStyle: 'normal',
        fontSize: 29,
        fontColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 255,
          index: 0,
        },
        lineHeight: 1.2900000000000003,
        strokeWidth: 0,
        strokeColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 255,
        },
        horizontalAlign: 'right',
        verticalAlign: 'center',
        backdropColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 1,
        },
        backdropPadding: 0,
        backdropBorderRadius: 0,
        backdropBorderWidth: 0,
        backdropBorderColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 255,
        },
      },
    },
    metadata: {
      role: 'text',
    },
  },
  {
    x: 604.4573974609378,
    y: 499.41179911295575,
    width: 382.8533010896747,
    height: 108.82359822591152,
    rotation: 0,
    visible: true,
    data: {
      type: 'text',
      content: [
        {
          text: 'Streamline Your Workflow with CASSI',
          fontFamily: 'Inter',
          fontWeight: 600,
          fontStyle: 'normal',
          fontSize: 37,
          fontColor: {
            r: 0,
            g: 0,
            b: 0,
            a: 255,
            index: 0,
          },
        },
      ],
      editMode: false,
      isLoading: false,
      options: {
        fontFamily: 'Inter',
        fontWeight: 600,
        fontStyle: 'normal',
        fontSize: 37,
        fontColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 255,
          index: 0,
        },
        lineHeight: 1.3000000000000003,
        strokeWidth: 0,
        strokeColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 255,
        },
        horizontalAlign: 'right',
        verticalAlign: 'center',
        backdropColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 1,
        },
        backdropPadding: 0,
        backdropBorderRadius: 0,
        backdropBorderWidth: 0,
        backdropBorderColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 255,
        },
      },
    },
    metadata: {
      role: 'subheader',
    },
  },
  // {
  //   x: 29,
  //   y: 902.1569315592453,
  //   width: 93.30040976381065,
  //   height: 98.86958066223121,
  //   rotation: 0,
  //   visible: true,
  //   data: {
  //     type: 'image',
  //     source: {
  //       type: 'url',
  //       url: 'https://media.licdn.com/dms/image/v2/D4E0BAQEHJJj24fi3Dw/company-logo_200_200/company-logo_200_200/0/1724406331151/magig_logo?e=2147483647&v=beta&t=cgPaR9pZH-QlxP6ZhfMY9nQu8lQqNtmD7K8vOKSn6bU',
  //     },
  //     isLoading: false,
  //     options: {
  //       mode: 'contain',
  //       opacity: 1,
  //       borderRadius: 25,
  //       borderWidth: 0,
  //       borderColor: {
  //         r: 0,
  //         g: 0,
  //         b: 0,
  //         a: 255,
  //       },
  //     },
  //   },
  //   metadata: {
  //     role: 'logo',
  //   },
  // },
  {
    x: 622.7907307942712,
    y: 205.82359822591158,
    width: 382.93492624721534,
    height: 75,
    rotation: 0,
    visible: true,
    data: {
      type: 'text',
      content: [
        {
          text: '#AIContentCreation,#BrandConsistency,#SocialMediaEfficiency',
          fontFamily: 'Inter',
          fontWeight: 400,
          fontStyle: 'normal',
          fontSize: 20,
          fontColor: {
            r: 0,
            g: 0,
            b: 0,
            a: 255,
            index: 4,
          },
        },
      ],
      editMode: false,
      isLoading: false,
      options: {
        fontFamily: 'Inter',
        fontWeight: 400,
        fontStyle: 'normal',
        fontSize: 20,
        fontColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 255,
          index: 4,
        },
        lineHeight: 1.3200000000000003,
        strokeWidth: 0,
        strokeColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 255,
        },
        horizontalAlign: 'right',
        verticalAlign: 'center',
        backdropColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 1,
        },
        backdropPadding: 0,
        backdropBorderRadius: 0,
        backdropBorderWidth: 0,
        backdropBorderColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 255,
        },
      },
    },
    metadata: {
      role: 'hashtags',
    },
  },
]

const template05 = (width: number, height: number): LayoutNode[] => [
  {
    x: 0,
    y: 0,
    width: width,
    height: height,
    rotation: 0,
    visible: true,
    data: {
      type: 'image',
      source: {
        type: 'url',
        url: 'blob:https://app.getcassi.ai/a276934a-e402-4285-ba45-4153ca4963e3',
      },
      isLoading: false,
      options: {
        mode: 'cover',
        opacity: 1,
        borderRadius: 0,
        borderWidth: 0,
        borderColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 255,
        },
      },
    },
    metadata: {
      role: 'image',
    },
  },
  {
    x: 20,
    y: 20,
    width: 700,
    height: 180,
    rotation: 0,
    visible: true,
    data: {
      type: 'text',
      content: [
        {
          text: 'AI-Powered Content Revolution',
          fontFamily: 'Abril Fatface',
          fontWeight: 400,
          fontStyle: 'normal',
          fontSize: 78,
          fontColor: {
            r: 255,
            g: 255,
            b: 255,
            a: 255,
            index: 0,
          },
        },
      ],
      editMode: false,
      isLoading: false,
      options: {
        fontFamily: 'Abril Fatface',
        fontWeight: 400,
        fontStyle: 'normal',
        fontSize: 78,
        fontColor: {
          r: 255,
          g: 255,
          b: 255,
          a: 255,
          index: 0,
        },
        lineHeight: 1,
        strokeWidth: 0,
        strokeColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 255,
        },
        horizontalAlign: 'left',
        verticalAlign: 'center',
        backdropColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 0,
        },
        backdropPadding: 0,
        backdropBorderRadius: 0,
        backdropBorderWidth: 0,
        backdropBorderColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 255,
        },
      },
    },
    metadata: {
      role: 'header',
    },
  },
  // {
  //   x: 893.8544299934483,
  //   y: 894.3607579001897,
  //   width: 88.14557000655168,
  //   height: 88.6392420998103,
  //   rotation: 0,
  //   visible: true,
  //   data: {
  //     type: 'image',
  //     source: {
  //       type: 'url',
  //       url: 'https://media.licdn.com/dms/image/v2/D4E0BAQEHJJj24fi3Dw/company-logo_200_200/company-logo_200_200/0/1724406331151/magig_logo?e=2147483647&v=beta&t=cgPaR9pZH-QlxP6ZhfMY9nQu8lQqNtmD7K8vOKSn6bU',
  //     },
  //     isLoading: false,
  //     options: {
  //       mode: 'contain',
  //       opacity: 1,
  //       borderRadius: 20,
  //       borderWidth: 0,
  //       borderColor: {
  //         r: 0,
  //         g: 0,
  //         b: 0,
  //         a: 255,
  //       },
  //     },
  //   },
  //   metadata: {
  //     role: 'logo',
  //   },
  // },
]

const _template06: LayoutNode[] = [
  {
    x: 0,
    y: 0,
    width: 1024,
    height: 1024,
    rotation: 0,
    visible: true,
    data: {
      type: 'image',
      source: {
        type: 'url',
        url: 'blob:http://localhost:5173/ada1a1ad-13b8-4935-bbea-24771c959171',
      },
      isLoading: false,
      options: {
        mode: 'cover',
        opacity: 1,
        borderRadius: 0,
        borderWidth: 0,
        borderColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 255,
        },
      },
    },
    metadata: {
      role: 'image',
    },
  },
  {
    x: 44.895365397135436,
    y: 44.91179911295575,
    width: 934.2092692057291,
    height: 934.1764017740885,
    rotation: 0,
    visible: true,
    data: {
      type: 'shape',
      isLoading: false,
      options: {
        shape: 'rectangle',
        fillColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 255,
          index: 3,
        },
        fillOpacity: 1,
        strokeColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 255,
        },
        strokeOpacity: 1,
        lineWidth: 0,
        borderRadius: 0,
      },
    },
    metadata: {
      role: 'static',
    },
  },
  // {
  //   x: 467.92721499672416,
  //   y: 821,
  //   width: 88.14557000655168,
  //   height: 88.6392420998103,
  //   rotation: 0,
  //   visible: true,
  //   data: {
  //     type: 'image',
  //     source: {
  //       type: 'url',
  //       url: 'https://media.licdn.com/dms/image/v2/D4E0BAQEHJJj24fi3Dw/company-logo_200_200/company-logo_200_200/0/1724406331151/magig_logo?e=2147483647&v=beta&t=cgPaR9pZH-QlxP6ZhfMY9nQu8lQqNtmD7K8vOKSn6bU',
  //     },
  //     isLoading: false,
  //     options: {
  //       mode: 'contain',
  //       opacity: 1,
  //       borderRadius: 20,
  //       borderWidth: 0,
  //       borderColor: {
  //         r: 0,
  //         g: 0,
  //         b: 0,
  //         a: 255,
  //       },
  //     },
  //   },
  //   metadata: {
  //     role: 'logo',
  //   },
  // },
  {
    x: 89.49999999999972,
    y: 184,
    width: 845.0000000000006,
    height: 490.49026489257847,
    rotation: 0,
    visible: true,
    data: {
      type: 'text',
      content: [
        {
          text: 'Try CASSI Now',
          fontFamily: 'Monoton',
          fontWeight: 400,
          fontStyle: 'normal',
          fontSize: 213,
          fontColor: {
            r: 0,
            g: 0,
            b: 0,
            a: 255,
            index: 0,
          },
        },
      ],
      editMode: false,
      isLoading: false,
      options: {
        fontFamily: 'Monoton',
        fontWeight: 400,
        fontStyle: 'normal',
        fontSize: 213,
        fontColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 255,
          index: 0,
        },
        lineHeight: 1,
        strokeWidth: 0,
        strokeColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 255,
        },
        horizontalAlign: 'center',
        verticalAlign: 'center',
        backdropColor: {
          r: 255,
          g: 255,
          b: 255,
          a: 0,
          index: -1,
        },
        backdropPadding: 0,
        backdropBorderRadius: 0,
        backdropBorderWidth: 0,
        backdropBorderColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 255,
        },
      },
    },
    metadata: {
      role: 'cta',
    },
  },
  {
    x: 89.49999999999972,
    y: 740.2642048580545,
    width: 845.0000000000005,
    height: 67.73579514194546,
    rotation: 0,
    visible: true,
    data: {
      type: 'text',
      content: [
        {
          text: '#AIProductivity #WorkSmarter #ContentInnovation',
          fontFamily: 'Inter',
          fontWeight: 300,
          fontStyle: 'normal',
          fontSize: 26,
          fontColor: {
            r: 255,
            g: 255,
            b: 255,
            a: 255,
            index: -1,
          },
        },
      ],
      editMode: false,
      isLoading: false,
      options: {
        fontFamily: 'Inter',
        fontWeight: 300,
        fontStyle: 'normal',
        fontSize: 26,
        fontColor: {
          r: 255,
          g: 255,
          b: 255,
          a: 255,
          index: -1,
        },
        lineHeight: 1,
        strokeWidth: 0,
        strokeColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 255,
        },
        horizontalAlign: 'center',
        verticalAlign: 'center',
        backdropColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 1,
        },
        backdropPadding: 0,
        backdropBorderRadius: 0,
        backdropBorderWidth: 0,
        backdropBorderColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 255,
        },
      },
    },
    metadata: {
      role: 'hashtags',
    },
  },
]

// TODO: currently we still have a problem with templates that do not have an image, because
// when we switch a template we have to get the image from the previous template, and if there
// is no image we loose it
// const template07: LayoutNode[] = [
//   {
//     x: -33,
//     y: -12,
//     width: 1143.7550395341027,
//     height: 1096.799768328807,
//     rotation: 0,
//     visible: true,
//     data: {
//       type: 'shape',
//       isLoading: false,
//       options: {
//         shape: 'rectangle',
//         fillColor: {
//           r: 0,
//           g: 0,
//           b: 0,
//           a: 255,
//           index: 3,
//         },
//         fillOpacity: 1,
//         strokeColor: {
//           r: 0,
//           g: 0,
//           b: 0,
//           a: 255,
//         },
//         strokeOpacity: 1,
//         lineWidth: 0,
//         borderRadius: 0,
//       },
//     },
//     metadata: {
//       role: 'static',
//     },
//   },
//   {
//     x: 312,
//     y: 823.7395179927369,
//     width: 200,
//     height: 80,
//     rotation: 0,
//     visible: true,
//     data: {
//       type: 'text',
//       content: 'Apply Now',
//       editMode: false,
//       isLoading: false,
//       options: {
//         fontFamily: 'Abril Fatface',
//         fontWeight: 400,
//         fontStyle: 'normal',
//         fontSize: 32,
//         fontColor: {
//           r: 0,
//           g: 0,
//           b: 0,
//           a: 255,
//           index: 4,
//         },
//         lineHeight: 1,
//         strokeWidth: 0,
//         strokeColor: {
//           r: 0,
//           g: 0,
//           b: 0,
//           a: 255,
//         },
//         horizontalAlign: 'center',
//         verticalAlign: 'center',
//         backdropColor: {
//           r: 255,
//           g: 255,
//           b: 255,
//           a: 255,
//           index: 0,
//         },
//         backdropPadding: 8,
//         backdropBorderRadius: 25,
//         backdropBorderWidth: 0,
//         backdropBorderColor: {
//           r: 0,
//           g: 0,
//           b: 0,
//           a: 255,
//         },
//       },
//     },
//     metadata: {
//       role: 'cta',
//     },
//   },
//   {
//     x: 232.27092377176274,
//     y: 66,
//     width: 559.4581524564745,
//     height: 150,
//     rotation: 0,
//     visible: true,
//     data: {
//       type: 'text',
//       content: 'HIRING',
//       editMode: false,
//       isLoading: false,
//       options: {
//         fontFamily: 'Abril Fatface',
//         fontWeight: 400,
//         fontStyle: 'normal',
//         fontSize: 80,
//         fontColor: {
//           r: 0,
//           g: 0,
//           b: 0,
//           a: 181,
//           index: -1,
//         },
//         lineHeight: 1,
//         strokeWidth: 0,
//         strokeColor: {
//           r: 0,
//           g: 0,
//           b: 0,
//           a: 255,
//         },
//         horizontalAlign: 'center',
//         verticalAlign: 'center',
//         backdropColor: {
//           r: 0,
//           g: 0,
//           b: 0,
//           a: 1,
//         },
//         backdropPadding: 0,
//         backdropBorderRadius: 0,
//         backdropBorderWidth: 0,
//         backdropBorderColor: {
//           r: 0,
//           g: 0,
//           b: 0,
//           a: 255,
//         },
//       },
//     },
//     metadata: {
//       role: 'header',
//     },
//   },
//   {
//     x: 114.64428739693756,
//     y: 315,
//     width: 794.7114252061249,
//     height: 266.6622064466658,
//     rotation: 0,
//     visible: true,
//     data: {
//       type: 'text',
//       content: 'Seeking Skilled React Developer',
//       editMode: false,
//       isLoading: false,
//       options: {
//         fontFamily: 'Abril Fatface',
//         fontWeight: 400,
//         fontStyle: 'normal',
//         fontSize: 91,
//         fontColor: {
//           r: 0,
//           g: 0,
//           b: 0,
//           a: 255,
//         },
//         lineHeight: 1.1900000000000002,
//         strokeWidth: 0,
//         strokeColor: {
//           r: 0,
//           g: 0,
//           b: 0,
//           a: 255,
//         },
//         horizontalAlign: 'center',
//         verticalAlign: 'center',
//         backdropColor: {
//           r: 0,
//           g: 0,
//           b: 0,
//           a: 1,
//         },
//         backdropPadding: 0,
//         backdropBorderRadius: 0,
//         backdropBorderWidth: 0,
//         backdropBorderColor: {
//           r: 0,
//           g: 0,
//           b: 0,
//           a: 255,
//         },
//       },
//     },
//     metadata: {
//       role: 'subheader',
//     },
//   },
//   // {
//   //   x: 558,
//   //   y: 813,
//   //   width: 97.17429706199437,
//   //   height: 101.47903598547373,
//   //   rotation: 0,
//   //   visible: true,
//   //   data: {
//   //     type: 'image',
//   //     source: {
//   //       type: 'url',
//   //       url: 'https://media.licdn.com/dms/image/v2/D4E0BAQEHJJj24fi3Dw/company-logo_200_200/company-logo_200_200/0/1724406331151/magig_logo?e=2147483647&v=beta&t=cgPaR9pZH-QlxP6ZhfMY9nQu8lQqNtmD7K8vOKSn6bU',
//   //     },
//   //     isLoading: false,
//   //     options: {
//   //       mode: 'contain',
//   //       opacity: 1,
//   //       borderRadius: 162,
//   //       borderWidth: 0,
//   //       borderColor: {
//   //         r: 0,
//   //         g: 0,
//   //         b: 0,
//   //         a: 255,
//   //       },
//   //     },
//   //   },
//   //   metadata: {
//   //     role: 'logo',
//   //   },
//   // },
// ]

const _template08: LayoutNode[] = [
  {
    x: 0,
    y: 0,
    width: 1024,
    height: 1024,
    rotation: 0,
    visible: true,
    data: {
      type: 'image',
      source: {
        type: 'url',
        url: 'blob:https://app.getcassi.ai/a87fdecb-5ced-4d03-ba04-93cff355cf04',
      },
      isLoading: false,
      options: {
        mode: 'cover',
        opacity: 1,
        borderRadius: 0,
        borderWidth: 0,
        borderColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 255,
        },
      },
    },
    metadata: {
      role: 'image',
    },
  },
  {
    x: 356.0612572429673,
    y: 425,
    width: 708.2975465838051,
    height: 109.03244792375972,
    rotation: 6,
    visible: true,
    data: {
      type: 'shape',
      isLoading: false,
      options: {
        shape: 'rectangle',
        fillColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 255,
          index: 0,
        },
        fillOpacity: 1,
        strokeColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 255,
        },
        strokeOpacity: 1,
        lineWidth: 0,
        borderRadius: 0,
      },
    },
    metadata: {
      role: 'static',
    },
  },
  {
    x: -138.32618495644272,
    y: 58.36400762912335,
    width: 798.6523699128854,
    height: 120.54373535964956,
    rotation: 0,
    visible: true,
    data: {
      type: 'shape',
      isLoading: false,
      options: {
        shape: 'rectangle',
        fillColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 255,
          index: 0,
        },
        fillOpacity: 1,
        strokeColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 255,
        },
        strokeOpacity: 1,
        lineWidth: 0,
        borderRadius: 0,
      },
    },
    metadata: {
      role: 'static',
    },
  },
  {
    x: 61,
    y: 884,
    width: 200,
    height: 80,
    rotation: 0,
    visible: true,
    data: {
      type: 'text',
      content: [
        {
          text: 'Apply Now',
          fontFamily: 'Abril Fatface',
          fontWeight: 400,
          fontStyle: 'normal',
          fontSize: 32,
          fontColor: {
            r: 0,
            g: 0,
            b: 0,
            a: 255,
            index: 4,
          },
        },
      ],
      editMode: false,
      isLoading: false,
      options: {
        fontFamily: 'Abril Fatface',
        fontWeight: 400,
        fontStyle: 'normal',
        fontSize: 32,
        fontColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 255,
          index: 4,
        },
        lineHeight: 1,
        strokeWidth: 0,
        strokeColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 255,
        },
        horizontalAlign: 'center',
        verticalAlign: 'center',
        backdropColor: {
          r: 255,
          g: 255,
          b: 255,
          a: 255,
          index: 0,
        },
        backdropPadding: 8,
        backdropBorderRadius: 25,
        backdropBorderWidth: 0,
        backdropBorderColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 255,
        },
      },
    },
    metadata: {
      role: 'cta',
    },
  },
  {
    x: 13,
    y: 73,
    width: 630.6620792959552,
    height: 91.27175061789626,
    rotation: 0,
    visible: true,
    data: {
      type: 'text',
      content: [
        {
          text: 'WE ARE HIRING',
          fontFamily: 'Alata',
          fontWeight: 400,
          fontStyle: 'normal',
          fontSize: 84,
          fontColor: {
            r: 0,
            g: 0,
            b: 0,
            a: 255,
            index: 4,
          },
        },
      ],
      editMode: false,
      isLoading: false,
      options: {
        fontFamily: 'Alata',
        fontWeight: 400,
        fontStyle: 'normal',
        fontSize: 84,
        fontColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 255,
          index: 4,
        },
        lineHeight: 1,
        strokeWidth: 0,
        strokeColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 255,
        },
        horizontalAlign: 'left',
        verticalAlign: 'center',
        backdropColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 1,
        },
        backdropPadding: 0,
        backdropBorderRadius: 0,
        backdropBorderWidth: 0,
        backdropBorderColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 255,
        },
      },
    },
    metadata: {
      role: 'header',
    },
  },
  {
    x: 383.0399331290177,
    y: 441,
    width: 627.3363420589587,
    height: 87.21040044382539,
    rotation: 6,
    visible: true,
    data: {
      type: 'text',
      content: [
        {
          text: 'Seeking Skilled React Developer',
          fontFamily: 'Mukta Malar',
          fontWeight: 700,
          fontStyle: 'normal',
          fontSize: 44,
          fontColor: {
            r: 0,
            g: 0,
            b: 0,
            a: 255,
            index: 3,
          },
        },
      ],
      editMode: false,
      isLoading: false,
      options: {
        fontFamily: 'Mukta Malar',
        fontWeight: 700,
        fontStyle: 'normal',
        fontSize: 44,
        fontColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 255,
          index: 3,
        },
        lineHeight: 1.04,
        strokeWidth: 0,
        strokeColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 255,
        },
        horizontalAlign: 'left',
        verticalAlign: 'center',
        backdropColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 1,
        },
        backdropPadding: 0,
        backdropBorderRadius: 0,
        backdropBorderWidth: 0,
        backdropBorderColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 255,
        },
      },
    },
    metadata: {
      role: 'subheader',
    },
  },
  // {
  //   x: 303.7156756333703,
  //   y: 873.2604820072631,
  //   width: 97.17429706199437,
  //   height: 101.47903598547373,
  //   rotation: 0,
  //   visible: true,
  //   data: {
  //     type: 'image',
  //     source: {
  //       type: 'url',
  //       url: 'https://media.licdn.com/dms/image/v2/D4E0BAQEHJJj24fi3Dw/company-logo_200_200/company-logo_200_200/0/1724406331151/magig_logo?e=2147483647&v=beta&t=cgPaR9pZH-QlxP6ZhfMY9nQu8lQqNtmD7K8vOKSn6bU',
  //     },
  //     isLoading: false,
  //     options: {
  //       mode: 'contain',
  //       opacity: 1,
  //       borderRadius: 162,
  //       borderWidth: 0,
  //       borderColor: {
  //         r: 0,
  //         g: 0,
  //         b: 0,
  //         a: 255,
  //       },
  //     },
  //   },
  //   metadata: {
  //     role: 'logo',
  //   },
  // },
]

const _template09: LayoutNode[] = [
  {
    x: 0,
    y: 0,
    width: 1024,
    height: 1024,
    rotation: 0,
    visible: true,
    data: {
      type: 'image',
      source: {
        type: 'url',
        url: 'blob:https://app.getcassi.ai/17bc6706-522f-4105-8741-765bc526a539',
      },
      isLoading: false,
      options: {
        mode: 'cover',
        opacity: 1,
        borderRadius: 0,
        borderWidth: 0,
        borderColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 255,
        },
      },
    },
    metadata: {
      role: 'image',
    },
  },
  {
    x: 573.3560385438202,
    y: 0,
    width: 573.3560385438202,
    height: 1024,
    rotation: 0,
    visible: true,
    data: {
      type: 'shape',
      isLoading: false,
      options: {
        shape: 'rectangle',
        fillColor: {
          r: 255,
          g: 213,
          b: 79,
          a: 152,
          index: 4,
        },
        fillOpacity: 1,
        strokeColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 255,
        },
        strokeOpacity: 1,
        lineWidth: 0,
        borderRadius: 0,
      },
    },
    metadata: {
      role: 'static',
    },
  },
  {
    x: 0,
    y: 0,
    width: 573.3560385438202,
    height: 1024,
    rotation: 0,
    visible: true,
    data: {
      type: 'shape',
      isLoading: false,
      options: {
        shape: 'rectangle',
        fillColor: {
          r: 255,
          g: 213,
          b: 79,
          a: 152,
          index: 2,
        },
        fillOpacity: 1,
        strokeColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 255,
        },
        strokeOpacity: 1,
        lineWidth: 0,
        borderRadius: 0,
      },
    },
    metadata: {
      role: 'static',
    },
  },
  {
    x: 128.10001717883324,
    y: 98.28367670364503,
    width: 715.5640081777437,
    height: 827.43264659271,
    rotation: 0,
    visible: true,
    data: {
      type: 'shape',
      isLoading: false,
      options: {
        shape: 'rectangle',
        fillColor: {
          r: 255,
          g: 213,
          b: 79,
          a: 45,
          index: 3,
        },
        fillOpacity: 1,
        strokeColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 255,
        },
        strokeOpacity: 1,
        lineWidth: 0,
        borderRadius: 0,
      },
    },
    metadata: {
      role: 'static',
    },
  },
  {
    x: 843.664025356577,
    y: 98.28367670364503,
    width: 267.0480517310634,
    height: 827.43264659271,
    rotation: 0,
    visible: true,
    data: {
      type: 'shape',
      isLoading: false,
      options: {
        shape: 'rectangle',
        fillColor: {
          r: 255,
          g: 213,
          b: 79,
          a: 152,
          index: 4,
        },
        fillOpacity: 1,
        strokeColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 255,
        },
        strokeOpacity: 1,
        lineWidth: 0,
        borderRadius: 0,
      },
    },
    metadata: {
      role: 'static',
    },
  },
  {
    x: 65,
    y: 620,
    width: 627.6927271629853,
    height: 345.0870188427425,
    rotation: 0,
    visible: true,
    data: {
      type: 'text',
      content: [
        {
          text: 'Ignite Your Professional Journey',
          fontFamily: 'Abril Fatface',
          fontWeight: 400,
          fontStyle: 'normal',
          fontSize: 103,
          fontColor: {
            r: 255,
            g: 255,
            b: 255,
            a: 255,
            index: 0,
          },
        },
      ],
      editMode: false,
      isLoading: false,
      options: {
        fontFamily: 'Abril Fatface',
        fontWeight: 400,
        fontStyle: 'normal',
        fontSize: 103,
        fontColor: {
          r: 255,
          g: 255,
          b: 255,
          a: 255,
          index: 0,
        },
        lineHeight: 1,
        strokeWidth: 0,
        strokeColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 255,
        },
        horizontalAlign: 'left',
        verticalAlign: 'center',
        backdropColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 1,
        },
        backdropPadding: 0,
        backdropBorderRadius: 0,
        backdropBorderWidth: 0,
        backdropBorderColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 255,
        },
      },
    },
    metadata: {
      role: 'header',
    },
  },
  {
    x: 705.3590418699238,
    y: 862.004610669216,
    width: 276.6099669733064,
    height: 63.71171262713892,
    rotation: 0,
    visible: true,
    data: {
      type: 'text',
      content: [
        {
          text: 'Register Now',
          fontFamily: 'Inter',
          fontWeight: 400,
          fontStyle: 'normal',
          fontSize: 32,
          fontColor: {
            r: 0,
            g: 0,
            b: 0,
            a: 255,
            index: 0,
          },
        },
      ],
      editMode: false,
      isLoading: false,
      options: {
        fontFamily: 'Inter',
        fontWeight: 400,
        fontStyle: 'normal',
        fontSize: 32,
        fontColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 255,
          index: 0,
        },
        lineHeight: 1,
        strokeWidth: 0,
        strokeColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 255,
        },
        horizontalAlign: 'center',
        verticalAlign: 'center',
        backdropColor: {
          r: 255,
          g: 255,
          b: 255,
          a: 0,
          index: -1,
        },
        backdropPadding: 8,
        backdropBorderRadius: 0,
        backdropBorderWidth: 3,
        backdropBorderColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 255,
          index: 1,
        },
      },
    },
    metadata: {
      role: 'cta',
    },
  },
  {
    x: -40,
    y: 264,
    width: 336.7084187394177,
    height: 58.779134149560264,
    rotation: 90,
    visible: true,
    data: {
      type: 'text',
      content: [
        {
          text: '#AIInnovation,#ProfessionalGrowth,#ContentRevolution',
          fontFamily: 'Inter',
          fontWeight: 300,
          fontStyle: 'normal',
          fontSize: 20,
          fontColor: {
            r: 255,
            g: 255,
            b: 255,
            a: 255,
            index: -1,
          },
        },
      ],
      editMode: false,
      isLoading: false,
      options: {
        fontFamily: 'Inter',
        fontWeight: 300,
        fontStyle: 'normal',
        fontSize: 20,
        fontColor: {
          r: 255,
          g: 255,
          b: 255,
          a: 255,
          index: -1,
        },
        lineHeight: 1.4100000000000004,
        strokeWidth: 0,
        strokeColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 255,
        },
        horizontalAlign: 'center',
        verticalAlign: 'center',
        backdropColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 1,
        },
        backdropPadding: 0,
        backdropBorderRadius: 0,
        backdropBorderWidth: 0,
        backdropBorderColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 255,
        },
      },
    },
    metadata: {
      role: 'hashtags',
    },
  },
]

const template10 = (width: number, height: number): LayoutNode[] => [
  {
    x: 0,
    y: 0,
    width: width,
    height: height,
    rotation: 0,
    visible: true,
    data: {
      type: 'image',
      source: {
        type: 'url',
        url: 'blob:https://app.getcassi.ai/17bc6706-522f-4105-8741-765bc526a539',
      },
      isLoading: false,
      options: {
        mode: 'cover',
        opacity: 1,
        borderRadius: 0,
        borderWidth: 0,
        borderColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 255,
        },
      },
    },
    metadata: {
      role: 'image',
    },
  },
  {
    x: width * 0.5,
    y: 0,
    width: width * 0.5,
    height: height,
    rotation: 0,
    visible: true,
    data: {
      type: 'shape',
      isLoading: false,
      options: {
        shape: 'rectangle',
        fillColor: {
          r: 255,
          g: 213,
          b: 79,
          a: 152,
          index: 4,
        },
        fillOpacity: 1,
        strokeColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 255,
        },
        strokeOpacity: 1,
        lineWidth: 0,
        borderRadius: 0,
      },
    },
    metadata: {
      role: 'static',
    },
  },
  {
    x: 0,
    y: 0,
    width: width * 0.5,
    height: height,
    rotation: 0,
    visible: true,
    data: {
      type: 'shape',
      isLoading: false,
      options: {
        shape: 'rectangle',
        fillColor: {
          r: 255,
          g: 213,
          b: 79,
          a: 152,
          index: 2,
        },
        fillOpacity: 1,
        strokeColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 255,
        },
        strokeOpacity: 1,
        lineWidth: 0,
        borderRadius: 0,
      },
    },
    metadata: {
      role: 'static',
    },
  },
  {
    x: 100,
    y: 100,
    width: (width - 200) * 0.7,
    height: height - 200,
    rotation: 0,
    visible: true,
    data: {
      type: 'shape',
      isLoading: false,
      options: {
        shape: 'rectangle',
        fillColor: {
          r: 255,
          g: 213,
          b: 79,
          a: 45,
          index: 3,
        },
        fillOpacity: 1,
        strokeColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 255,
        },
        strokeOpacity: 1,
        lineWidth: 0,
        borderRadius: 0,
      },
    },
    metadata: {
      role: 'static',
    },
  },
  {
    x: (width - 200) * 0.7 + 100,
    y: 100,
    width: (width - 200) * 0.2,
    height: height - 200,
    rotation: 0,
    visible: true,
    data: {
      type: 'shape',
      isLoading: false,
      options: {
        shape: 'rectangle',
        fillColor: {
          r: 255,
          g: 213,
          b: 79,
          a: 152,
          index: 4,
        },
        fillOpacity: 1,
        strokeColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 255,
        },
        strokeOpacity: 1,
        lineWidth: 0,
        borderRadius: 0,
      },
    },
    metadata: {
      role: 'static',
    },
  },
  {
    x: -300,
    y: -50,
    width: width * 0.7,
    height: height * 0.7,
    rotation: 0,
    visible: true,
    data: {
      type: 'shape',
      isLoading: false,
      options: {
        shape: 'circle',
        fillColor: {
          r: 62,
          g: 39,
          b: 35,
          a: 106,
          index: 3,
        },
        fillOpacity: 1,
        strokeColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 255,
        },
        strokeOpacity: 1,
        lineWidth: 0,
        borderRadius: 0,
      },
    },
    metadata: {
      role: 'static',
    },
  },
  {
    x: width - 300 - 50,
    y: height - 75 - 50,
    width: 300,
    height: 75,
    rotation: 0,
    visible: true,
    data: {
      type: 'text',
      content: [
        {
          text: 'Register Now',
          fontFamily: 'Inter',
          fontWeight: 400,
          fontStyle: 'normal',
          fontSize: 32,
          fontColor: {
            r: 0,
            g: 0,
            b: 0,
            a: 255,
            index: 0,
          },
        },
      ],
      editMode: false,
      isLoading: false,
      options: {
        fontFamily: 'Inter',
        fontWeight: 400,
        fontStyle: 'normal',
        fontSize: 32,
        fontColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 255,
          index: 0,
        },
        lineHeight: 1,
        strokeWidth: 0,
        strokeColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 255,
        },
        horizontalAlign: 'center',
        verticalAlign: 'center',
        backdropColor: {
          r: 255,
          g: 255,
          b: 255,
          a: 0,
          index: -1,
        },
        backdropPadding: 8,
        backdropBorderRadius: 0,
        backdropBorderWidth: 3,
        backdropBorderColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 255,
          index: 1,
        },
      },
    },
    metadata: {
      role: 'cta',
    },
  },
  {
    x: width * 0.5 - 100,
    y: height * 0.5,
    width: 350,
    height: 50,
    rotation: 90,
    visible: true,
    data: {
      type: 'text',
      content: [
        {
          text: '#AIInnovation,#ProfessionalGrowth,#ContentRevolution',
          fontFamily: 'Inter',
          fontWeight: 300,
          fontStyle: 'normal',
          fontSize: 20,
          fontColor: {
            r: 255,
            g: 255,
            b: 255,
            a: 255,
            index: -1,
          },
        },
      ],
      editMode: false,
      isLoading: false,
      options: {
        fontFamily: 'Inter',
        fontWeight: 300,
        fontStyle: 'normal',
        fontSize: 20,
        fontColor: {
          r: 255,
          g: 255,
          b: 255,
          a: 255,
          index: -1,
        },
        lineHeight: 1.4100000000000004,
        strokeWidth: 0,
        strokeColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 255,
        },
        horizontalAlign: 'center',
        verticalAlign: 'center',
        backdropColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 1,
        },
        backdropPadding: 0,
        backdropBorderRadius: 0,
        backdropBorderWidth: 0,
        backdropBorderColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 255,
        },
      },
    },
    metadata: {
      role: 'hashtags',
    },
  },
  {
    x: 50,
    y: 50,
    width: 700,
    height: 350,
    rotation: 0,
    visible: true,
    data: {
      type: 'text',
      content: [
        {
          text: 'Ignite Your Professional Journey',
          fontFamily: 'Abril Fatface',
          fontWeight: 400,
          fontStyle: 'normal',
          fontSize: 103,
          fontColor: {
            r: 255,
            g: 255,
            b: 255,
            a: 255,
            index: 0,
          },
        },
      ],
      editMode: false,
      isLoading: false,
      options: {
        fontFamily: 'Abril Fatface',
        fontWeight: 400,
        fontStyle: 'normal',
        fontSize: 103,
        fontColor: {
          r: 255,
          g: 255,
          b: 255,
          a: 255,
          index: 0,
        },
        lineHeight: 1,
        strokeWidth: 0,
        strokeColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 255,
        },
        horizontalAlign: 'left',
        verticalAlign: 'top',
        backdropColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 1,
        },
        backdropPadding: 0,
        backdropBorderRadius: 0,
        backdropBorderWidth: 0,
        backdropBorderColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 255,
        },
      },
    },
    metadata: {
      role: 'header',
    },
  },
  // {
  //   x: 28,
  //   y: 914.5760445207252,
  //   width: 83.85800648971215,
  //   height: 83.81534877458103,
  //   rotation: 0,
  //   visible: true,
  //   data: {
  //     type: 'image',
  //     source: {
  //       type: 'url',
  //       url: 'https://media.licdn.com/dms/image/v2/D4E0BAQEHJJj24fi3Dw/company-logo_200_200/company-logo_200_200/0/1724406331151/magig_logo?e=2147483647&v=beta&t=cgPaR9pZH-QlxP6ZhfMY9nQu8lQqNtmD7K8vOKSn6bU',
  //     },
  //     isLoading: false,
  //     options: {
  //       mode: 'contain',
  //       opacity: 0.63,
  //       borderRadius: 37,
  //       borderWidth: 0,
  //       borderColor: {
  //         r: 0,
  //         g: 0,
  //         b: 0,
  //         a: 255,
  //       },
  //     },
  //   },
  //   metadata: {
  //     role: 'logo',
  //   },
  // },
]

const _template11: LayoutNode[] = [
  {
    x: 0,
    y: -5.629600587806635,
    width: 1024,
    height: 1035.2592011756133,
    rotation: 0,
    visible: true,
    data: {
      type: 'shape',
      isLoading: false,
      options: {
        shape: 'rectangle',
        fillColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 255,
          index: 2,
        },
        fillOpacity: 1,
        strokeColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 255,
        },
        strokeOpacity: 1,
        lineWidth: 0,
        borderRadius: 0,
      },
    },
    metadata: {
      role: 'static',
    },
  },
  {
    x: 164.63401206727582,
    y: 164.68350571092077,
    width: 694.7319758654484,
    height: 694.6329885781585,
    rotation: 0,
    visible: true,
    data: {
      type: 'image',
      source: {
        type: 'url',
        url: 'blob:https://app.getcassi.ai/17bc6706-522f-4105-8741-765bc526a539',
      },
      isLoading: false,
      options: {
        mode: 'contain',
        opacity: 1,
        borderRadius: 0,
        borderWidth: 0,
        borderColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 255,
        },
      },
    },
    metadata: {
      role: 'image',
    },
  },
  {
    x: 512,
    y: 505.171414486511,
    width: 385.5823881151539,
    height: 409.40463003421416,
    rotation: 0,
    visible: true,
    data: {
      type: 'shape',
      isLoading: false,
      options: {
        shape: 'rectangle',
        fillColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 255,
          index: 2,
        },
        fillOpacity: 1,
        strokeColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 255,
        },
        strokeOpacity: 1,
        lineWidth: 0,
        borderRadius: 0,
      },
    },
    metadata: {
      role: 'static',
    },
  },
  {
    x: 512,
    y: -6.828585513488974,
    width: 347.36598793272424,
    height: 1037.657171026978,
    rotation: 0,
    visible: true,
    data: {
      type: 'shape',
      isLoading: false,
      options: {
        shape: 'rectangle',
        fillColor: {
          r: 255,
          g: 213,
          b: 79,
          a: 152,
          index: 4,
        },
        fillOpacity: 1,
        strokeColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 255,
        },
        strokeOpacity: 1,
        lineWidth: 0,
        borderRadius: 0,
      },
    },
    metadata: {
      role: 'static',
    },
  },
  {
    x: 337.17752148864696,
    y: 339.4069969349837,
    width: 694.7319758654485,
    height: 345.0870188427425,
    rotation: 270,
    visible: true,
    data: {
      type: 'text',
      content: [
        {
          text: 'Ignite Your Professional Journey',
          fontFamily: 'Bebas Neue',
          fontWeight: 400,
          fontStyle: 'normal',
          fontSize: 67,
          fontColor: {
            r: 255,
            g: 255,
            b: 255,
            a: 255,
            index: 0,
          },
        },
      ],
      editMode: false,
      isLoading: false,
      options: {
        fontFamily: 'Bebas Neue',
        fontWeight: 400,
        fontStyle: 'normal',
        fontSize: 67,
        fontColor: {
          r: 255,
          g: 255,
          b: 255,
          a: 255,
          index: 0,
        },
        lineHeight: 1,
        strokeWidth: 0,
        strokeColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 255,
        },
        horizontalAlign: 'left',
        verticalAlign: 'center',
        backdropColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 1,
        },
        backdropPadding: 0,
        backdropBorderRadius: 0,
        backdropBorderWidth: 0,
        backdropBorderColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 255,
        },
      },
    },
    metadata: {
      role: 'header',
    },
  },
  // {
  //   x: 28,
  //   y: 914.5760445207252,
  //   width: 83.85800648971215,
  //   height: 83.81534877458103,
  //   rotation: 0,
  //   visible: true,
  //   data: {
  //     type: 'image',
  //     source: {
  //       type: 'url',
  //       url: 'https://media.licdn.com/dms/image/v2/D4E0BAQEHJJj24fi3Dw/company-logo_200_200/company-logo_200_200/0/1724406331151/magig_logo?e=2147483647&v=beta&t=cgPaR9pZH-QlxP6ZhfMY9nQu8lQqNtmD7K8vOKSn6bU',
  //     },
  //     isLoading: false,
  //     options: {
  //       mode: 'contain',
  //       opacity: 0.63,
  //       borderRadius: 37,
  //       borderWidth: 0,
  //       borderColor: {
  //         r: 0,
  //         g: 0,
  //         b: 0,
  //         a: 255,
  //       },
  //     },
  //   },
  //   metadata: {
  //     role: 'logo',
  //   },
  // },
  {
    x: 187,
    y: 130.5354604546959,
    width: 300.2864208064175,
    height: 68.29609051244975,
    rotation: 0,
    visible: true,
    data: {
      type: 'text',
      content: [
        {
          text: '#AIInnovation,#ProfessionalGrowth,#ContentRevolution',
          fontFamily: 'Bebas Neue',
          fontWeight: 400,
          fontStyle: 'normal',
          fontSize: 24,
          fontColor: {
            r: 0,
            g: 0,
            b: 0,
            a: 255,
            index: 0,
          },
        },
      ],
      editMode: false,
      isLoading: false,
      options: {
        fontFamily: 'Bebas Neue',
        fontWeight: 400,
        fontStyle: 'normal',
        fontSize: 24,
        fontColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 255,
          index: 0,
        },
        lineHeight: 1.2000000000000002,
        strokeWidth: 0,
        strokeColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 255,
        },
        horizontalAlign: 'left',
        verticalAlign: 'center',
        backdropColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 1,
        },
        backdropPadding: 0,
        backdropBorderRadius: 0,
        backdropBorderWidth: 0,
        backdropBorderColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 255,
        },
      },
    },
    metadata: {
      role: 'hashtags',
    },
  },
]

const template12 = (width: number, height: number): LayoutNode[] => [
  {
    x: 0,
    y: 0,
    width: width,
    height: height,
    rotation: 0,
    visible: true,
    data: {
      type: 'image',
      source: {
        type: 'url',
        url: 'blob:https://app.getcassi.ai/a276934a-e402-4285-ba45-4153ca4963e3',
      },
      isLoading: false,
      options: {
        mode: 'cover',
        opacity: 1,
        borderRadius: 0,
        borderWidth: 0,
        borderColor: {
          r: 0,
          g: 0,
          b: 0,
          a: 255,
        },
      },
    },
    metadata: {
      role: 'image',
    },
  },
]

export const templates: Templates = [
  // template01,
  // template02,
  // template03,
  // template04,
  template05,
  // template06,
  // template07,
  // template08,
  // template09,
  template10,
  // template11,
  template12,
]

/**
 * Creates a text node with options customized by role (header, subheader, text, etc.)
 */
export const textNode = (
  role: Role,
  content: string,
  canvas: { width: number; height: number },
): LayoutNode => {
  const baseOptions: TextOptions = {
    fontFamily: 'Inter',
    fontWeight: 400,
    fontStyle: 'normal',
    fontSize: 32,
    fontColor: Color({ r: 0, g: 0, b: 0 }),
    lineHeight: 1,
    strokeWidth: 0,
    strokeColor: Color({ r: 0, g: 0, b: 0 }),
    horizontalAlign: 'center',
    verticalAlign: 'center',
    backdropColor: Color({ r: 0, g: 0, b: 0, a: 1 }),
    backdropPadding: 0,
    backdropBorderRadius: 0,
    backdropBorderWidth: 0,
    backdropBorderColor: Color({ r: 0, g: 0, b: 0 }),
  }

  // NOTE: update options for each role like font size, font color, etc.
  const rolesOptions: Partial<Record<Role, Partial<TextOptions>>> = {
    header: { fontWeight: 700, fontSize: 50 },
    subheader: { fontWeight: 600, fontSize: 32 },
    text: { fontWeight: 400, fontSize: 20 },
    hashtags: { fontWeight: 300, fontSize: 20 },
    cta: {
      fontWeight: 400,
      fontSize: 32,
      fontColor: Color({ r: 0, g: 0, b: 0 }),
      backdropColor: Color({ r: 255, g: 255, b: 255 }),
      backdropPadding: 8,
      backdropBorderRadius: 25,
    },
  }

  const defaultSize = { width: 300, height: 150 }

  // NOTE: update sizes for each role, if needed we can extend this for other base options
  const roleSizes: Partial<Record<Role, { width: number; height: number }>> = {
    header: { width: 400, height: 150 },
    subheader: { width: 350, height: 175 },
    cta: { width: 200, height: 80 },
  }

  const options: TextOptions = { ...baseOptions, ...rolesOptions[role] }
  const { width, height } = { ...defaultSize, ...roleSizes[role] }

  const centerX = (canvas.width - width) / 2
  const centerY = (canvas.height - height) / 2

  return {
    x: centerX,
    y: centerY,
    width,
    height,
    rotation: 0,
    visible: true,
    data: {
      type: 'text',
      content: stringToRuns(content, options),
      editMode: false,
      isLoading: false,
      options,
    },
    metadata: { role },
  }
}

export const imageNode = (
  role: 'image' | 'logo',
  url: string,
  canvas: { width: number; height: number },
  width?: number,
  height?: number,
): LayoutNode => {
  const nodeWidth = width || canvas.width
  const nodeHeight = height || canvas.height

  const centerX = (canvas.width - nodeWidth) / 2
  const centerY = (canvas.height - nodeHeight) / 2

  return {
    x: centerX,
    y: centerY,
    width: nodeWidth,
    height: nodeHeight,
    rotation: 0,
    visible: true,
    data: {
      type: 'image',
      source: { type: 'url', url },
      isLoading: false,
      options: {
        mode: 'contain',
        opacity: 1,
        borderRadius: 0,
        borderWidth: 0,
        borderColor: Color({ r: 0, g: 0, b: 0 }),
      },
    },
    metadata: { role },
  }
}

export const shapeNode = (
  shape: 'rectangle' | 'circle' | 'triangle',
  canvas: { width: number; height: number },
): LayoutNode => {
  const nodeWidth = 300
  const nodeHeight = 300

  const centerX = (canvas.width - nodeWidth) / 2
  const centerY = (canvas.height - nodeHeight) / 2

  const fillColor = Color({ r: 0, g: 0, b: 0 })
  const fillColorWithIndex: ColorType = { ...fillColor, index: 4 }

  return {
    x: centerX,
    y: centerY,
    width: nodeWidth,
    height: nodeHeight,
    rotation: 0,
    visible: true,
    data: {
      type: 'shape',
      isLoading: false,
      options: {
        shape: shape,
        fillColor: fillColorWithIndex,
        fillOpacity: 1,
        strokeColor: Color({ r: 0, g: 0, b: 0 }),
        strokeOpacity: 1,
        lineWidth: 0,
        borderRadius: 0,
      },
    },
    metadata: { role: 'static' },
  }
}
